import Tracker from "@openreplay/tracker";

export const tracker = new Tracker({
  projectKey: process.env.NEXT_PUBLIC_OPEN_REPLAY_KEY,
});
